<template>
  <div class="contents">
    <MobilePlanDivider />

    <div
      class="grid grid-cols-1 gap-y-16 p-16 lg:grid-cols-[max-content,auto,max(18.5rem)] lg:gap-y-0 lg:p-32"
    >
      <div class="flex w-full flex-row items-center">
        <div
          class="p-10 lg:p-12 h-60 w-60 lg:h-[120px] lg:w-[120px] flex items-center justify-center"
          data-test="mobile-plan-image"
        >
          <MobilePlanLogo
            :partner-name="bundledMobilePlan.partnerProvider"
            :size="80"
          />
        </div>

        <MobilePlanContent
          class="ml-8 lg:ml-0 lg:hidden"
          :contract-commitment-label="bundledMobilePlan.contractCommitmentLabel"
          :mobile-plan-offer-label="bundledMobilePlan.mobilePlanOfferLabel"
          :price-label="bundledMobilePlan.priceLabel"
          :price-sub-label="bundledMobilePlan.priceSubLabel"
          :state="bundledMobilePlan.state"
        />
      </div>

      <div
        class="hidden lg:flex lg:size-full lg:flex-col lg:justify-start lg:py-0 lg:pl-24 lg:pr-56"
      >
        <MobilePlanContent
          class="lg:mb-24 lg:mt-32"
          :contract-commitment-label="bundledMobilePlan.contractCommitmentLabel"
          :mobile-plan-offer-label="bundledMobilePlan.mobilePlanOfferLabel"
          :price-label="bundledMobilePlan.priceLabel"
          :price-sub-label="bundledMobilePlan.priceSubLabel"
          :state="bundledMobilePlan.state"
        />
      </div>

      <div class="flex h-full flex-col justify-center">
        <MobilePlanActions
          :mobile-plan-actions="bundledMobilePlan.actions"
          :orderline-id
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import MobilePlanLogo from '~/components/MobilePlanLogo/MobilePlanLogo.vue'

import type { MobilePlanProps } from './MobilePlan.types'
import MobilePlanActions from './components/MobilePlanActions/MobilePlanActions.vue'
import MobilePlanContent from './components/MobilePlanContent/MobilePlanContent.vue'
import MobilePlanDivider from './components/MobilePlanDivider/MobilePlanDivider.vue'

defineProps<MobilePlanProps>()
</script>
